import { ProductSlider } from "./js/ClassProductSlider";

window.addEventListener("DOMContentLoaded", () => {
	const productSliders = document.querySelectorAll(".product-slider");

	productSliders.forEach((s) => {
		const x = new ProductSlider(s);
		x.init();
	});
});
